import React from 'react';

import { useCurrentUser, useCurrentCustomer } from 'src/store';
import { identifyUser as identifyHotjarUser } from 'src/lib/hotjar';
import { identifyUser as identifyFullstoryUser } from 'src/lib/fullStory';

const UserAnalyticsUpdater = () => {
  const currentUser = useCurrentUser();
  const currentCustomer = useCurrentCustomer();

  React.useEffect(() => {
    if (!currentUser) {
      return undefined;
    }

    // Identify user and customer in tracking services
    identifyHotjarUser(currentUser, currentCustomer);
    identifyFullstoryUser(currentUser, currentCustomer);

    return undefined;
  }, [currentUser, currentCustomer]);

  return null;
};

export default UserAnalyticsUpdater;
